import * as XLSX from 'xlsx';
import type { WorkSheet } from 'xlsx';

/**
 * `aoa_to_sheet`로 넣은 숫자 셀에 천 단위 표시(예: #,##0). 값은 숫자 타입 유지.
 */
export function applyThousandsFormatToNumericCellsInColumn(
  ws: WorkSheet,
  colIndex: number,
  format = '#,##0'
): void {
  const ref = ws['!ref'];
  if (!ref) return;
  const range = XLSX.utils.decode_range(ref);
  for (let r = range.s.r; r <= range.e.r; r++) {
    const addr = XLSX.utils.encode_cell({ r, c: colIndex });
    const cell = ws[addr] as { t?: string; v?: unknown; z?: string } | undefined;
    if (cell && cell.t === 'n' && typeof cell.v === 'number') {
      cell.z = format;
    }
  }
}

/**
 * SheetJS(xlsx) 워크시트 `!cols` — 데이터 열 최대 길이 기준(한글·숫자 가중)
 * 열 너비 단위 wch는 대략 문자 수에 해당
 */
export function xlsxSheetColWidthsFromAoa(aoa: (string | number)[][]): { wch: number }[] {
  if (!aoa.length) return [];
  const colCount = Math.max(...aoa.map(r => r.length), 0);
  const maxLens = Array(colCount).fill(0);
  for (const row of aoa) {
    for (let j = 0; j < row.length; j++) {
      const s = row[j] == null ? '' : String(row[j]);
      let w = 0;
      for (const ch of s) {
        w += ch.charCodeAt(0) > 127 ? 1.85 : 1;
      }
      if (w > maxLens[j]) maxLens[j] = w;
    }
  }
  return maxLens.map(len => ({
    wch: Math.min(Math.max(Math.ceil(len + 2), 10), 60),
  }));
}

/** 데이터 행 기본 높이(pt) — 너무 좁지 않게 */
export function xlsxSheetRowsFromRowCount(rowCount: number, hpt = 18): { hpt: number }[] {
  return Array.from({ length: rowCount }, () => ({ hpt }));
}
